import { Component, OnInit, Input } from '@angular/core';
import { AssessmentResult } from '../../../shared/models/assessment-result';
import { ScaleResult } from '../../../shared/models/scale-result';

@Component({
  selector: 'dac-summary-section-graph-item',
  templateUrl: './summary-section-graph-item.component.html',
  styleUrls: ['./summary-section-graph-item.component.scss']
})
export class SummarySectionGraphItemComponent implements OnInit {
  @Input() item:any;
  @Input() scaleResults:ScaleResult[];
  @Input() assessmentResult:AssessmentResult;
  
  constructor() { }

  ngOnInit() {
  }

  get PCLSummaryScaleResult() {
    if (this.scaleResults && this.scaleResults.length) {
      return this.scaleResults[0]; // first and only item for the PCL
    }
    return null;
  }

  getRangeNameForFirstScaleResult(scaleResults:ScaleResult[]) {
    if (scaleResults && scaleResults.length >= 1
      && scaleResults[0].range) {
      return scaleResults[0].range.displayName
    }
    return "";
  }

  getClasses(item:any) {
    if (item.chartSize) {
      let result = "p-" + item.chartSize + "-chart";
      return [result];
    }
    else {
      return ["p-small-chart"];
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/reports/report-items/summary-section-graph-item/summary-section-graph-item.component.ts